var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Reports__View" },
    [
      _vm.tabs.length
        ? _c("EntityListLayout", {
            ref: "entity",
            attrs: { tabs: _vm.tabs },
            on: { onNewEntitySave: _vm.onNewEntitySave },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _vm._v(
                        "שאלות חשיפה לפרק " +
                          _vm._s(_vm.expoChapter.displayName)
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "button",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "10px",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "button-close",
                              on: { click: _vm.createExerciseFromExpo },
                            },
                            [_vm._v("צור כתרגול רב ברירה")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "link-button",
                              on: { click: _vm.addExpoChapterQuestion },
                            },
                            [_vm._v(" הוספת שאלות חשיפה לפרק ")]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "counter",
                  fn: function (slotProps) {
                    return [
                      _vm._v(' סה"כ '),
                      _c("b", [
                        _vm._v(_vm._s(_vm.getTotalRecords(slotProps)) + " "),
                      ]),
                    ]
                  },
                },
              ],
              null,
              false,
              2582547571
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }